import type { Event } from '@/types';

export interface CalendarDayData {
  date: Date;
  events?: Event[];
}

export const CalendarStartDays = {
  SUNDAY: 'sunday',
  MONDAY: 'monday',
} as const;

export type CalendarStartDay =
  (typeof CalendarStartDays)[keyof typeof CalendarStartDays];
